import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/prospektus-logotipo.png")